import axios from "../utils/axios";

export const getCouponRedemptions = async (params = {}) => {
  try {
    const response = await axios.get("/admin/coupons/redemptions", { params });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch coupon redemptions"
    );
  }
};
